export default __webpack_public_path__ + "static/media/share_24px.12dd27ae.svg";